module.exports = __webpack_public_path__ + "img/img05.f0693b64.jpg";